// extracted by mini-css-extract-plugin
module.exports = {"button":"BackToTop_button__8PGg4","backToTop":"BackToTop_backToTop__YDj7r","backToTop__button":"BackToTop_backToTop__button__9O8nb"};